export default function JobTabs({
  activeTab,
  setActiveTab,
  counts,
  setSelectedJob,
}) {
  return (
    <div className="relative flex gap-6 border-b border-gray-200 mb-6">
      {["queue", "completed", "failed"].map((key) => (
        <button
          key={key}
          onClick={() => {
            setActiveTab(key);
            setSelectedJob(null);
          }}
          className={`relative pb-3 text-sm capitalize transition-all duration-200 ${
            activeTab === key
              ? "text-gray-900 font-semibold"
              : "text-gray-500 hover:text-gray-800"
          }`}
        >
          {key} ({counts[key]}){/* underline */}
          {activeTab === key && (
            <div className="absolute left-0 -bottom-[1px] h-[2px] w-full bg-indigo-600 rounded-full transition-all duration-300" />
          )}
        </button>
      ))}
    </div>
  );
}
